import React from 'react';
import { Button, Form, Header, Segment, Grid } from 'semantic-ui-react';

import recuperacaoService from '../services/recuperacao.service';
import Loader from './Loader';

class RecuperarSenha extends React.Component {

    constructor(props) {
        super(props);

        const { location } = this.props;
        const query = new URLSearchParams(location.search);
        const token = query.get('token');

        this.state = {
            isLoading: true,
            novaSenha: '',
            confSenha: '',
            location,
            query,
            token
        };
    }

    async componentDidMount() {
        const { token } = this.state;
        if (!token) {
            this.handleCancelar();
        } else {
            try {
                const { success } = await recuperacaoService.verificarAsync(token);

                if (success) {
                    this.setState({ isLoading: false });
                } else {
                    this.setState({ isLoading: false, token: '' });
                }
            } catch (e) {
                console.log(e);
                this.handleCancelar();
            }
        }
    }

    handleOk = async () => {
        let msg = '';
        const { token, novaSenha, confSenha } = this.state;

        if (novaSenha === confSenha) {
            try {
                this.setState({ isLoading: true });
                var credentials = { token, novaSenha, confSenha };
                const { success } = await recuperacaoService.recuperarAsync(credentials);

                if (success) {
                    alert('Senha alterada com sucesso!');
                    this.handleCancelar();
                    return;
                } else {
                    msg = 'Dados inválidos, tente novamente!';

                    this.setState({
                        novaSenha: '',
                        confSenha: ''
                    });
                }
            } catch (e) {
                console.log(e);
                msg = 'Erro ao validar os dados informados, tente novamente!';

                this.setState({
                    novaSenha: '',
                    confSenha: ''
                });

            } finally {
                this.setState({ isLoading: false });
            }
        } else {
            msg = 'Repita a nova senha corretamente!'
        }

        if (msg) {
            alert(msg);
        }
    };

    handleCancelar = () => {
        const { history } = this.props;
        history.push('/');
    };

    render() {
        const { token, novaSenha, confSenha } = this.state;

        return (

            <Segment className={this.props.className}>
                <Loader isLoading={this.state.isLoading} />
                <Header as='h2'>
                    <p>REDEFINIR SENHA</p>
                </Header>

                <Form size='large'>

                    {token ? <React.Fragment>
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            placeholder='Senha nova'
                            value={novaSenha}
                            type='password'
                            onChange={(e) => this.setState({ novaSenha: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            placeholder='Repetir senha nova'
                            value={confSenha}
                            type='password'
                            onChange={(e) => this.setState({ confSenha: e.target.value })}
                        />
                    </React.Fragment> : <p>Sua requisição de alteração de senha expirou, tente novamente.</p>}

                    <Grid>
                        <Grid.Column width={16} floated='right' textAlign='right'>
                            {token ? <Button size='large' onClick={this.handleOk}>
                                <div style={{ width: '70px' }}>Ok</div>
                            </Button > : null}
                            <Button size='large' onClick={this.handleCancelar}>
                                <div style={{ width: '70px' }}>{token ? 'Cancelar' : 'Voltar'}</div>
                            </Button >
                        </Grid.Column>
                    </Grid>
                </Form>
            </Segment>
        );
    }
}

export default RecuperarSenha;